import { render, staticRenderFns } from "./TabbarLayout.vue?vue&type=template&id=b2f6edd0&scoped=true"
import script from "./TabbarLayout.vue?vue&type=script&lang=js"
export * from "./TabbarLayout.vue?vue&type=script&lang=js"
import style0 from "./TabbarLayout.vue?vue&type=style&index=0&id=b2f6edd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f6edd0",
  null
  
)

export default component.exports